import { UnnamedMetric } from '@fullstory/proto/fs/services/dx-objects';
import { getOrgId } from '@fullstory/redux/modules/fullstory/selectors';
import {
  generateRoutePath,
  METRIC_CREATE_WITH_HASH_ROUTE,
  METRIC_DETAILS_WITH_HASH_ROUTE,
} from '@fullstory/routes';
import { isEqual } from 'lodash';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { UnnamedMetricFormValues } from '../model';
import { useSavedMetricsActions } from './useSavedMetricsActions';

export const useCreateUnnamedMetricPath = (): ((formValues: UnnamedMetricFormValues) => string) => {
  const orgId = useSelector(getOrgId);
  const { createUnnamedMetric } = useSavedMetricsActions();

  const createUnnamedMetricPath = useCallback(
    ({
      metric,
      segments,
      timeRange,
      timeInterval,
      dimensionSettings,
      unnamedMetric,
      metricId,
      timeRangeComparison,
      singleNumberColor,
    }: UnnamedMetricFormValues): string => {
      // when values change, create new unnamed metric and push new route hash to the history stack
      const newUnnamedMetric: UnnamedMetric = {
        id: metric.id || undefined,
        name: metric.name,
        description: metric.description,
        metric: metric.metric,
        segments,
        segmentIds: [],
        timeRange,
        timeInterval,
        display: metric.display,
        dimensionSettings,
        timeRangeComparison,
        singleNumberColor,
      };
      if (isEqual(unnamedMetric, newUnnamedMetric)) return '';

      const metricHash = createUnnamedMetric({ ...newUnnamedMetric, id: undefined });
      return metricId
        ? generateRoutePath(METRIC_DETAILS_WITH_HASH_ROUTE, {
            orgId,
            id: metricId,
            hash: metricHash,
          })
        : generateRoutePath(METRIC_CREATE_WITH_HASH_ROUTE, {
            orgId,
            hash: metricHash,
          });
    },
    [orgId, createUnnamedMetric],
  );
  return createUnnamedMetricPath;
};
